import React from 'react';
import Form from 'react-bootstrap/Form';

import DropdownFacet from '../../DropdownFacet/DropdownFacet';
import ToggleFacet from '../../ToggleFacet/ToggleFacet';

import styles from './PracticeFacets.module.css';

const PracticeFacets = (props) => {

	const onPracticeSelectionChanged = (selection) => {
		console.log("Practice: ", selection.value);
		props.onFacetChanged('practice', selection.value);
	};

	const onHospitalAffiliationChanged = (selection) => {
		props.onFacetChanged('hospital', selection);
	}

	const onLanguageChanged = (selection) => {
		props.onFacetChanged('language', selection);
	}

	const onSpecialtyChanged = (selection) => {
		props.onFacetChanged('specialty', selection);
	}

	const onTermChanged = (selection) => {
		props.onFacetChanged('term', selection);
	}

	const onIsBookableFlagChanged = (event) => {
		props.onToggleChanged('is_bookable', event.target.checked);
	}

	const onIsBookableOnlineFlagChanged = (event) => {
		props.onToggleChanged('online_scheduling', event.target.checked);
	}

	const onHasAcpsFlagChanged = (event) => {
		props.onToggleChanged('is_acp', event.target.checked);
	}

	const onHasPcpsFlagChanged = (event) => {
		props.onToggleChanged('is_pcp', event.target.checked);
	}

	let specialty_facet_options = [];
	if(props.facets.specialty !== undefined) {
		specialty_facet_options = props.facets.specialty.map(specialty => {
			return {
				value: specialty.slug,
				label: specialty.name
			};
		});
	}

	let hospital_facet_options = [];
	if(props.facets.hospitals !== undefined) {
		hospital_facet_options = props.facets.hospitals.map(hospital => {
			return {
				value: hospital.slug,
				label: hospital.name
			};
		});
	}

	let language_facet_options = [];
	if(props.facets.languages !== undefined) {
		language_facet_options = props.facets.languages.map(language => {
			return {
				value: language.slug,
				label: language.name
			};
		});
	}

	let term_facet_options = [];
	if(props.facets.terms !== undefined) {
		term_facet_options = props.facets.terms.map(term => {
			return {
				value: term.slug,
				label: term.name
			};
		});
	}

	return (
		<div className={styles.facets}>
			<Form>
				<h2>Search Pratices</h2>
				<DropdownFacet
					label="Practice ID / Name"
					placeholder="Practice ID / Name"
					options={[]}
					onChange={onPracticeSelectionChanged} />
				<DropdownFacet
					label="Specialty"
					placeholder="Specialty"
					isMulti
					options={specialty_facet_options}
					onChange={onSpecialtyChanged} />
				<DropdownFacet
					label="Clinical Focus Terms"
					placeholder="Terms"
					isMulti
					options={term_facet_options}
					onChange={onTermChanged} />
				<DropdownFacet
					label="Hospital Affiliation"
					placeholder="Hospital Affiliation"
					isMulti
					options={hospital_facet_options}
					onChange={onHospitalAffiliationChanged} />
				<DropdownFacet
					label="Languages"
					placeholder="Languages"
					isMulti
					options={language_facet_options}
					onChange={onLanguageChanged} />
				<ToggleFacet
					label="Is Bookable"
					onChange={onIsBookableFlagChanged} />
				<ToggleFacet
					label="Is Bookable Online"
					onChange={onIsBookableOnlineFlagChanged} />
				<ToggleFacet
					label="Has PCPs"
					onChange={onHasPcpsFlagChanged} />
				<ToggleFacet
					label="Has ACPs"
					onChange={onHasAcpsFlagChanged} />
			</Form>
		</div>
	);
}

export default PracticeFacets;